import { render, staticRenderFns } from "./CustomsPackingStatistics.vue?vue&type=template&id=a0d429a6&scoped=true"
import script from "./CustomsPackingStatistics.vue?vue&type=script&lang=ts"
export * from "./CustomsPackingStatistics.vue?vue&type=script&lang=ts"
import style0 from "./CustomsPackingStatistics.vue?vue&type=style&index=0&id=a0d429a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d429a6",
  null
  
)

export default component.exports